import { Browser } from '@capacitor/browser';
import { BasePage } from 'src/pages/base.page';

export class CommandNotificationModel {
    public ation: String
    public value: String

    private ACTION_REDIRECT = 'action_redirect'
    private ACTION_WEBVIEW = 'action_webview'
    private ACTION_WEBPAGE = 'action_webpage'

    constructor(command: any) {
        this.ation = command.action
        this.value = command.value
    }

    public execute(context: BasePage) {
        switch(this.ation) {
            case this.ACTION_REDIRECT:
                context.openPageByUrl(this.value, { skipLocationChange: true })
            break;
            case this.ACTION_WEBVIEW:
                let url = '/webview/' + context.encodeData(this.value)
                context.openPage(url)
            break;
            case this.ACTION_WEBPAGE:
                Browser.open({ url: this.value.toString() });
            break;
        }   
    }
}